import { Navigate } from "react-router-dom";
import { useAdminAuth } from "./AuthContext";

export default function ProtectedAdmin({ children }) {
  const { user } = useAdminAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#4A0E1F] font-body text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
        Loading the atelier…
      </div>
    );
  }
  if (!user || !user.email) return <Navigate to="/admin/login" replace />;
  return children;
}
